import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const PublicHeader: React.FC = () => {
  const location = useLocation();
  const path = location.pathname;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  // Helper function to determine if a link is active
  const isActive = (linkPath: string) => {
    return path === linkPath;
  };

  // Toggle drawer menu
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <header className="bg-white shadow-sm border-b border-slate-200 py-4 relative">
      <div className="container mx-auto px-4 flex flex-wrap items-center justify-between">
        {/* Center Logo */}
        <div className="flex-1 flex justify-center">
          <img src="/assets/img/logoHeaderRazi.png" alt="آزمایشگاه رازی" className="h-16" />
        </div>
        
        {/* Mobile menu button */}
        <button 
          onClick={toggleDrawer}
          className="md:hidden order-1 p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none"
          aria-label="Toggle menu"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
     
        {/* Desktop Navigation */}
        <nav className="hidden md:flex order-2 items-center">
          <ul className="flex space-x-2 space-x-reverse">
            <li>
              <Link 
                to="/" 
                className={`px-4 py-2 ${isActive('/') ? 'bg-blue-600 text-white' : 'text-blue-600 hover:text-blue-800'} rounded-md text-sm font-medium`}
              >
                صفحه اصلی
              </Link>
            </li>
            <li>
              <Link 
                to="/about" 
                className={`px-4 py-2 ${isActive('/about') ? 'bg-blue-600 text-white' : 'text-blue-600 hover:text-blue-800'} rounded-md text-sm font-medium`}
              >
                درباره ما
              </Link>
            </li>
            <li>
              <Link 
                to="/contact" 
                className={`px-4 py-2 ${isActive('/contact') ? 'bg-blue-600 text-white' : 'text-blue-600 hover:text-blue-800'} rounded-md text-sm font-medium`}
              >
                تماس با ما
              </Link>
            </li>
            <li>
              <Link 
                to="/guide" 
                className={`px-4 py-2 ${isActive('/guide') ? 'bg-blue-600 text-white' : 'text-blue-600 hover:text-blue-800'} rounded-md text-sm font-medium`}
              >
                راهنما
              </Link>
            </li>
            <li>
              <Link 
                to="/home" 
                className="mr-4 px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded-md text-sm font-medium"
              >
                ورود / ثبت‌نام
              </Link>
            </li>
          </ul>
        </nav>
      </div>

      {/* Mobile Drawer Menu */}
      <div 
        className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 ${isDrawerOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        onClick={toggleDrawer}
      ></div>
      <div 
        className={`fixed top-0 right-0 w-64 h-full bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${isDrawerOpen ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="p-4 border-b flex justify-between items-center">
          <h2 className="text-lg font-medium">منو</h2>
          <button 
            onClick={toggleDrawer}
            className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none"
            aria-label="بستن منو"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <nav className="p-4">
          <ul className="space-y-3">
            <li>
              <Link 
                to="/" 
                className={`block px-4 py-2 ${isActive('/') ? 'bg-blue-600 text-white' : 'text-blue-600 hover:bg-blue-50'} rounded-md`}
                onClick={toggleDrawer}
              >
                صفحه اصلی
              </Link>
            </li>
            <li>
              <Link 
                to="/about" 
                className={`block px-4 py-2 ${isActive('/about') ? 'bg-blue-600 text-white' : 'text-blue-600 hover:bg-blue-50'} rounded-md`}
                onClick={toggleDrawer}
              >
                درباره ما
              </Link>
            </li>
            <li>
              <Link 
                to="/contact" 
                className={`block px-4 py-2 ${isActive('/contact') ? 'bg-blue-600 text-white' : 'text-blue-600 hover:bg-blue-50'} rounded-md`}
                onClick={toggleDrawer}
              >
                تماس با ما
              </Link>
            </li>
            <li>
              <Link 
                to="/guide" 
                className={`block px-4 py-2 ${isActive('/guide') ? 'bg-blue-600 text-white' : 'text-blue-600 hover:bg-blue-50'} rounded-md`}
                onClick={toggleDrawer}
              >
                راهنما
              </Link>
            </li>
            <li className="mt-6">
              <Link 
                to="/home" 
                className="block w-full px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded-md text-center"
                onClick={toggleDrawer}
              >
                ورود / ثبت‌نام
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default PublicHeader; 